import APIClient from '@/shared/http/clients/api'

const resourceName = 'Atividade'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAtividades = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAtividades/`, data, config)

const AprActivitiesRepository = {
  GetAtividades
}

export default AprActivitiesRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprAtividade.js